import AppDispatcher from '../stores/AppDispatcher'
import ManageConstants from '../constants/ManageConstants'
import UserConstants from '../constants/UserConstants'
import UserStore from '../stores/UserStore'
import {changeProjectName} from '../api/changeProjectName'
import {changeProjectAssignee} from '../api/changeProjectAssignee'
import {changeProjectTeam} from '../api/changeProjectTeam'
import {getSecondPassReview} from '../api/getSecondPassReview'
import {getUserData} from '../api/getUserData'
import {getTeamMembers} from '../api/getTeamMembers'
import {createTeam} from '../api/createTeam'
import {addUserTeam} from '../api/addUserTeam'
import {removeTeamUser} from '../api/removeTeamUser'
import {updateTeamName} from '../api/updateTeamName'
import CatToolActions from './CatToolActions'
import {changeProjectStatus} from '../api/changeProjectStatus'
import {changeJobStatus} from '../api/changeJobStatus'
import UserActions from './UserActions'
import {fromJS} from 'immutable'

let ManageActions = {
  /********* Projects *********/

  /** Render the list of projects
   * @param projects
   * @param team
   * @param teams
   * @param hideSpinner
   * */
  renderProjects: function (
    projects,
    team,
    teams,
    hideSpinner,
    filtering = false,
  ) {
    this.popupInfoTeamsStorageName = 'infoTeamPopup-' + config.userMail
    AppDispatcher.dispatch({
      actionType: ManageConstants.RENDER_PROJECTS,
      projects,
      team,
      teams,
      hideSpinner,
      filtering,
    })
  },

  updateProjects: function (projects) {
    AppDispatcher.dispatch({
      actionType: ManageConstants.UPDATE_PROJECTS,
      projects: projects,
    })
  },

  /** Render the more projects
   * @param projects
   */
  renderMoreProjects: function (projects) {
    AppDispatcher.dispatch({
      actionType: ManageConstants.RENDER_MORE_PROJECTS,
      project: projects,
    })
  },
  /** Open the translate page with the options tab open
   * @param job
   * @param prName
   */
  openJobSettings: function (job, prName) {
    AppDispatcher.dispatch({
      actionType: ManageConstants.OPEN_JOB_SETTINGS,
      job: job,
      prName: prName,
    })
  },

  /** Open the translate page with the TM tab open
   * @param job
   * @param prName
   */
  openJobTMPanel: function (job, prName) {
    AppDispatcher.dispatch({
      actionType: ManageConstants.OPEN_JOB_TM_PANEL,
      job: job,
      prName: prName,
    })
  },

  updateStatusProject: function (project, status) {
    changeProjectStatus(
      project.get('id'),
      project.get('password'),
      status,
    ).then(() => {
      AppDispatcher.dispatch({
        actionType: ManageConstants.HIDE_PROJECT,
        project: project,
      })
      setTimeout(function () {
        ManageActions.removeProject(project)
      }, 1000)
    })
  },

  changeJobStatus: function (project, job, status) {
    changeJobStatus(job.get('id'), job.get('password'), status).then(() => {
      if (project.get('jobs').size === 1) {
        AppDispatcher.dispatch({
          actionType: ManageConstants.HIDE_PROJECT,
          project,
        })

        setTimeout(() => {
          AppDispatcher.dispatch({
            actionType: ManageConstants.REMOVE_JOB,
            project: project,
            job: job,
          })
        }, 1000)
      } else {
        AppDispatcher.dispatch({
          actionType: ManageConstants.REMOVE_JOB,
          project: project,
          job: job,
        })
      }
    })
  },

  changeJobPassword: function (
    project,
    job,
    password,
    oldPassword,
    revision_number,
    translator,
  ) {
    AppDispatcher.dispatch({
      actionType: ManageConstants.CHANGE_JOB_PASS,
      projectId: project.get('id'),
      jobId: job.get('id'),
      password: password,
      oldPassword: oldPassword,
      revision_number,
      oldTranslator: translator,
    })
  },
  //TODO: remove
  changeJobPasswordFromOutsource: function (
    project,
    job,
    password,
    oldPassword,
  ) {
    AppDispatcher.dispatch({
      actionType: ManageConstants.CHANGE_JOB_PASS,
      projectId: project.id,
      jobId: job.id,
      password: password,
      oldPassword: oldPassword,
    })
  },

  noMoreProjects: function () {
    AppDispatcher.dispatch({
      actionType: ManageConstants.NO_MORE_PROJECTS,
    })
  },

  showReloadSpinner: function () {
    AppDispatcher.dispatch({
      actionType: ManageConstants.SHOW_RELOAD_SPINNER,
    })
  },

  filterProjects: function (member, name, status) {
    this.showReloadSpinner()
    const memberUid =
      member && member.toJS ? member.get('user').get('uid') : member
    AppDispatcher.dispatch({
      actionType: ManageConstants.FILTER_PROJECTS,
      memberUid,
      name,
      status,
    })
  },

  removeProject: function (project) {
    AppDispatcher.dispatch({
      actionType: ManageConstants.REMOVE_PROJECT,
      project: project,
    })
  },

  showNotificationProjectsChanged: function () {
    var notification = {
      title: 'Ooops...',
      text: 'Something went wrong, the project has been assigned to another member or moved to another team.',
      type: 'warning',
      position: 'bl',
      allowHtml: true,
      autoDismiss: false,
    }
    CatToolActions.addNotification(notification)
  },

  changeProjectAssignee: function (team, project, user) {
    const uid = user ? user.get('uid') : null
    changeProjectAssignee(team.get('id'), project.get('id'), uid)
      .then(() => {
        AppDispatcher.dispatch({
          actionType: ManageConstants.CHANGE_PROJECT_ASSIGNEE,
          project: project,
          user: user,
        })
        getTeamMembers(team.get('id')).then(function (data) {
          team = team.set('members', data.members)
          team = team.set('pending_invitations', data.pending_invitations)
          AppDispatcher.dispatch({
            actionType: UserConstants.UPDATE_TEAM,
            team: team.toJS(),
          })
        })

        const name = user?.toJS
          ? user.get('first_name') + ' ' + user.get('last_name')
          : 'Not assigned'

        const notification = {
          title: 'Assignee changed',
          text:
            'The project ' +
            project.get('name') +
            ' has been assigned to ' +
            name,
          type: 'success',
          position: 'bl',
          allowHtml: true,
          timer: 3000,
        }
        CatToolActions.addNotification(notification)
      })
      .catch(() => {
        ManageActions.showNotificationProjectsChanged()
        AppDispatcher.dispatch({
          actionType: ManageConstants.RELOAD_PROJECTS,
        })
      })
  },

  changeProjectAssigneeBulk: function (idAssignee, projects, teams) {
    let team = teams.find((team) => team.id === projects[0].id_team)
    const {user} = team.members.find(({id}) => id === idAssignee)

    getTeamMembers(team.id).then((data) => {
      team.members = data.members
      team.pending_invitations = data.pending_invitations

      AppDispatcher.dispatch({
        actionType: UserConstants.UPDATE_TEAM,
        team: team,
      })

      const promises = projects.map((project) => {
        return changeProjectAssignee(team.id, project.id, user.uid)
      })

      Promise.allSettled(promises).then((result) => {
        const fulfilledPromises = result
          .filter(({status}) => status === 'fulfilled')
          .map(({value}) => value)

        fulfilledPromises.forEach((value) => {
          AppDispatcher.dispatch({
            actionType: ManageConstants.CHANGE_PROJECT_ASSIGNEE,
            project: fromJS(value.project),
            user: fromJS(user),
          })
        })

        if (fulfilledPromises.length) {
          const notification = {
            title: 'Assignee changed',
            text: `The selected projects have been successfully assigned to ${user.first_name} ${user.last_name}.`,
            type: 'warning',
            position: 'bl',
            allowHtml: true,
            timer: 10000,
          }
          CatToolActions.addNotification(notification)
        } else if (fulfilledPromises.length < result.length) {
          const errorNotification = {
            title: 'Change assignee project',
            text: 'Some projects failed',
            type: 'error',
            position: 'bl',
            allowHtml: true,
            timer: 10000,
          }
          CatToolActions.addNotification(errorNotification)
        }
      })
    })
  },

  changeProjectName: function (project, newName) {
    changeProjectName({
      idProject: project.get('id'),
      passwordProject: project.get('password'),
      newName,
    }).then((response) => {
      AppDispatcher.dispatch({
        actionType: ManageConstants.CHANGE_PROJECT_NAME,
        project: project,
        newName: response.name,
      })
    })
  },

  changeProjectTeam: function (teamId, project) {
    changeProjectTeam(teamId, project.toJS())
      .then(() => {
        var team = UserStore.teams.find(function (team) {
          return team.get('id') == teamId
        })
        team = team.toJS()
        const selectedTeam = UserStore.getSelectedTeam()
        if (selectedTeam.type == 'personal' && team.type !== 'personal') {
          getTeamMembers(teamId).then(function (data) {
            team.members = data.members
            team.pending_invitations = data.pending_invitations
            AppDispatcher.dispatch({
              actionType: UserConstants.UPDATE_TEAM,
              team: team,
            })
            setTimeout(function () {
              AppDispatcher.dispatch({
                actionType: ManageConstants.CHANGE_PROJECT_TEAM,
                project: project,
                teamId: teamId,
              })
            })
          })
        } else if (
          teamId !== selectedTeam.id &&
          selectedTeam.type !== 'personal'
        ) {
          setTimeout(function () {
            AppDispatcher.dispatch({
              actionType: ManageConstants.HIDE_PROJECT,
              project: project,
            })
          }, 500)
          setTimeout(function () {
            AppDispatcher.dispatch({
              actionType: ManageConstants.REMOVE_PROJECT,
              project: project,
            })
          }, 1000)
          let notification = {
            title: 'Project Moved',
            text:
              'The project ' +
              project.get('name') +
              ' has been moved to the ' +
              team.name +
              ' Team',
            type: 'success',
            position: 'bl',
            allowHtml: true,
            timer: 3000,
          }
          CatToolActions.addNotification(notification)
          getTeamMembers(selectedTeam.id).then(function (data) {
            selectedTeam.members = data.members
            selectedTeam.pending_invitations = data.pending_invitations
            AppDispatcher.dispatch({
              actionType: UserConstants.UPDATE_TEAM,
              team: selectedTeam,
            })
            setTimeout(function () {
              AppDispatcher.dispatch({
                actionType: ManageConstants.CHANGE_PROJECT_TEAM,
                project: project,
                teamId: selectedTeam.id,
              })
            })
          })
        }
      })
      .catch(() => {
        ManageActions.showNotificationProjectsChanged()
        AppDispatcher.dispatch({
          actionType: ManageConstants.RELOAD_PROJECTS,
        })
      })
  },

  changeProjectsTeamBulk: function (teamId, projects) {
    let team = UserStore.teams.find(function (team) {
      return team.get('id') == teamId
    })
    team = team.toJS()
    const selectedTeam = UserStore.getSelectedTeam()

    const teamObjectReference =
      selectedTeam.type === 'personal' && team.type !== 'personal'
        ? team
        : selectedTeam

    getTeamMembers(teamObjectReference.id).then((data) => {
      teamObjectReference.members = data.members
      teamObjectReference.pending_invitations = data.pending_invitations

      AppDispatcher.dispatch({
        actionType: UserConstants.UPDATE_TEAM,
        team: teamObjectReference,
      })

      const promises = projects.map((project) =>
        changeProjectTeam(teamId, project),
      )

      Promise.allSettled(promises).then((result) => {
        const fulfilledPromises = result
          .filter(({status}) => status === 'fulfilled')
          .map(({value}) => value)

        fulfilledPromises.forEach((value) => {
          const project = fromJS(value.project)
          if (teamId !== selectedTeam.id && selectedTeam.type !== 'personal') {
            setTimeout(function () {
              AppDispatcher.dispatch({
                actionType: ManageConstants.HIDE_PROJECT,
                project,
              })
            }, 500)

            setTimeout(function () {
              AppDispatcher.dispatch({
                actionType: ManageConstants.REMOVE_PROJECT,
                project,
              })
            }, 1000)
          }

          setTimeout(function () {
            AppDispatcher.dispatch({
              actionType: ManageConstants.CHANGE_PROJECT_TEAM,
              project,
              teamId: teamObjectReference.id,
            })
          })
        })
        if (fulfilledPromises.length) {
          const notification = {
            title: 'Projects moved',
            text: `The selected projects have been successfully moved to the ${team.name} team.`,
            type: 'warning',
            position: 'bl',
            allowHtml: true,
            timer: 10000,
          }
          CatToolActions.addNotification(notification)
        } else if (fulfilledPromises.length < result.length) {
          const errorNotification = {
            title: 'Change projects team',
            text: 'Some projects failed',
            type: 'error',
            position: 'bl',
            allowHtml: true,
            timer: 10000,
          }
          CatToolActions.addNotification(errorNotification)
        }
      })
    })
  },

  assignTranslator: function (projectId, jobId, jobPassword, translator) {
    if (document.body.classList.contains('manage')) {
      AppDispatcher.dispatch({
        actionType: ManageConstants.ASSIGN_TRANSLATOR,
        projectId: projectId,
        jobId: jobId,
        jobPassword: jobPassword,
        translator: translator,
      })
    }
  },

  enableDownloadButton: function (id) {
    AppDispatcher.dispatch({
      actionType: ManageConstants.ENABLE_DOWNLOAD_BUTTON,
      idProject: id,
    })
  },

  disableDownloadButton: function (id) {
    AppDispatcher.dispatch({
      actionType: ManageConstants.DISABLE_DOWNLOAD_BUTTON,
      idProject: id,
    })
  },

  checkPopupInfoTeams: function () {
    var openPopup = localStorage.getItem(this.popupInfoTeamsStorageName)
    if (!openPopup) {
      ManageActions.openPopupTeams()
    }
  },

  setPopupTeamsCookie: function () {
    localStorage.setItem(this.popupInfoTeamsStorageName, true)
  },

  getSecondPassReview: function (
    idProject,
    passwordProject,
    idJob,
    passwordJob,
  ) {
    return getSecondPassReview(
      idProject,
      passwordProject,
      idJob,
      passwordJob,
    ).then((data) => {
      AppDispatcher.dispatch({
        actionType: ManageConstants.ADD_SECOND_PASS,
        idProject: idProject,
        passwordProject: passwordProject,
        idJob: idJob,
        passwordJob: passwordJob,
        secondPassPassword: data.chunk_review.review_password,
      })
    })
  },

  /********* Modals *********/

  openModifyTeamModal: function (team) {
    getTeamMembers(team.id).then(function (data) {
      team.members = data.members
      team.pending_invitations = data.pending_invitations
      AppDispatcher.dispatch({
        actionType: ManageConstants.OPEN_MODIFY_TEAM_MODAL,
        team: team,
        hideChangeName: false,
      })
    })
  },

  openAddTeamMemberModal: function (team) {
    getTeamMembers(team.id).then(function (data) {
      team.members = data.members
      team.pending_invitations = data.pending_invitations
      AppDispatcher.dispatch({
        actionType: ManageConstants.OPEN_MODIFY_TEAM_MODAL,
        team: team,
        hideChangeName: true,
      })
    })
  },

  openPopupTeams: function () {
    AppDispatcher.dispatch({
      actionType: ManageConstants.OPEN_INFO_TEAMS_POPUP,
    })
  },

  /********* Teams: actions from modals *********/

  /**
   * Called from manage modal
   * @param teamName
   * @param members
   */
  createTeam: function (teamName, members) {
    createTeam(teamName, members).then((response) => {
      let team = response.team
      this.showReloadSpinner()
      UserActions.setTeamInStorage(team.id)
      AppDispatcher.dispatch({
        actionType: UserConstants.ADD_TEAM,
        team: team,
      })
      AppDispatcher.dispatch({
        actionType: UserConstants.CHOOSE_TEAM,
        teamId: team.id,
      })
    })
  },

  changeTeam: function (team) {
    this.showReloadSpinner()
    UserActions.setTeamInStorage(team.id)
    getTeamMembers(team.id).then(function (data) {
      let selectedTeam = team
      selectedTeam.members = data.members
      selectedTeam.pending_invitations = data.pending_invitations
      AppDispatcher.dispatch({
        actionType: UserConstants.UPDATE_TEAM,
        team: selectedTeam,
      })
      AppDispatcher.dispatch({
        actionType: UserConstants.CHOOSE_TEAM,
        teamId: selectedTeam.id,
      })
    })
  },

  addUserToTeam: function (team, userEmail) {
    addUserTeam(team.toJS(), userEmail).then(function (data) {
      AppDispatcher.dispatch({
        actionType: ManageConstants.UPDATE_TEAM_MEMBERS,
        team: team,
        members: data.members,
        pending_invitations: data.pending_invitations,
      })
    })
  },

  removeUserFromTeam: function (team, user) {
    const self = this
    const userId = user.get('uid')
    const userInfo = UserStore.getUser()
    removeTeamUser(team.toJS(), userId).then(function (data) {
      if (userId === userInfo.user.uid) {
        const selectedTeam = UserStore.getSelectedTeam()

        if (selectedTeam.id === team.get('id')) {
          getUserData().then(function (data) {
            AppDispatcher.dispatch({
              actionType: UserConstants.RENDER_TEAMS,
              teams: data.teams,
            })
            self.changeTeam(data.teams[0])
          })
        } else {
          AppDispatcher.dispatch({
            actionType: ManageConstants.REMOVE_TEAM,
            team: team,
          })
        }
      } else {
        AppDispatcher.dispatch({
          actionType: ManageConstants.UPDATE_TEAM_MEMBERS,
          team: team,
          members: data.members,
          pending_invitations: data.pending_invitations,
        })
      }
      AppDispatcher.dispatch({
        actionType: ManageConstants.RELOAD_PROJECTS,
      })
    })
  },

  changeTeamName: function (team, newName) {
    updateTeamName(team, newName).then(function (data) {
      AppDispatcher.dispatch({
        actionType: ManageConstants.UPDATE_TEAM_NAME,
        oldTeam: team,
        team: data.team[0],
      })
    })
  },
  storeSelectedTeam: function (selectedTeam) {
    AppDispatcher.dispatch({
      actionType: ManageConstants.SELECTED_TEAM,
      selectedTeam,
    })
  },
  reloadProjects: function () {
    AppDispatcher.dispatch({
      actionType: ManageConstants.RELOAD_PROJECTS,
    })
  },
}

export default ManageActions
